/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_2025_Q4Inputs */

const en_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Exclusive Trees  | Azalea、Flaming Katy、Dandelion、Snowdrop、Reed |  
| --- | --- | 
| Selected Trees | Scarecrow、Mushroom、Ginkgo、Purple Oak Tree、Chocolate Strawberry Cake、Bear's Paw、Celestial Tree、Four-Leaf Clover、Sundae Tree、Twilight Guardian、Plum Blossom、Geraniums、Snowflake Bush、Mistletoe Wreath、Balloon Flower |
| Plus-Exclusive Sounds | After Snow、Summer Shake、Autumn Whisper |
| Selected Sounds | Night forest、(Lofi) Morning Trail、(Lofi) Lazy Rose Dance、Cozy Fireplace、Japanese Garden、(Piano) Heartstring Whispers、Waking Groove |`)
};

const ar_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| اشجار بلس الحصرية | أزاليا、المتوهجه كاتى、زهرة الهندباء、زهرة الثلج、قصب | 
| --- | --- | 
| أشجار مختارة | خيال مآتة、ماشروم、جنكو、شجرة بلوط بنفسجى、كيك شوكولاتة فراولة、مخلب الدب、الشجرة السماوية、زهرة رباعية、شجرة مثلجات、حارس الشفق、زهرة البرقوق、جيرانيومس、شجيرة الثلج、إكليل الهدال、زهرة البالون |
| اصوات بلس الحصرية | بعد الثلج、اهتزاز الصيف、همس الخريف |
| الأصوات المختارة | ليل الغابة、(لوفي) درب الصباح、(لوفي) رقصة الوردة الكسولة、مدفأة مريحة、الحديقة اليابانية、(بيانو) همسات وتر القلب、إيقاع الاستيقاظ |`)
};

const de_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Exclusive Trees | Azalee、Flammende Katy、Löwenzahn、Schneeglöckchen、Schilfrohr | 
| --- | --- | 
| Ausgewählte Bäume | Vogelscheuche、Pilz、Ginkgo、Lila Eiche、Schokotorte mit Erdbeeren、Bärentatze、Himmlischen Baum、Vierblättriges Kleeblatt、Eisbecher-Baum、Twilight Guardian、Pflaumenblüte、Geranien、Schneeflockenstrauch、Mistelzweig Kranz、Ballon-Blume |
| Plus-Exclusive Sounds | Nach Schnee、Sommer-Shake、Herbstgeflüster | 
| Ausgewählte Klänge | Nächtlicher Wald、(Lofi) Morgenpfad、(Lofi) Lazy Rose Dance、Gemütliche Feuerstelle、Japanischer Garten、(Klavier) Das Flüstern der Herzsaite、Waking Groove |`)
};

const es_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Árboles Exclusivos Plus | Azalea、Kalanchoe、Diente de león、Campanilla de invierno、Junco |  
| --- | --- |
| Árboles Seleccionados | Espantapájaros、Seta、Ginkgo、Roble morado、Pastel de chocolate y fresas、Pata de oso、Árbol Celestial、Trébol de cuatro hojas、Árbol de helado、Guardián del crepúsculo、Flor de ciruelo、Geranios、Arbusto copo de nieve、Guirnalda de muérdago、Flor globo |
| Sonidos Exclusivos Plus | Después de la nieve、Batido de verano、Susurro otoñal |
| Sonidos Seleccionados | Bosque nocturno、(Lofi) Sendero Matinal、(Lofi) Baile de la Rosa Perezosa、Chimenea acogedora、Jardín japonés、(Piano) Susurros del corazón、El ritmo del despertar |`)
};

const fr_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Arbres exclusifs Plus | Azalée、Kalanchoé Flamboyant、Pissenlit、Perce-neige、Roseau |
| --- | --- |
| Arbres sélectionnés | Épouvantail、Champignon、Ginkgo、Chêne violet、Gâteau au chocolat et fraises、Patte d'ours、Arbre céleste、Trèfle à quatre feuilles、Arbre Sundae、Gardien du crépuscule、Fleur de prunier、Géraniums、Buisson enneigé、Couronne de Gui、Campanule à grandes fleurs |
| Sons exclusifs Plus | Après la neige、Percussions d'été、Murmure d’automne |
| Sons sélectionnés | Forêt de nuit、(Lofi) Chemin d'Aurore、(Lofi) Valse Tranquille des Roses、Coin du Feu Douillet、Jardin japonais、(Piano) Murmures du cœur、Réveil en Rythme |`)
};

const it_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Più alberi esclusivi | Azalea、Calancoe Fiorita、Dente di Leone、Bucaneve、Giunco |  
| --- | --- | 
| Alberi selezionati | Spaventapasseri、Fungo、Ginkgo、Quercia Viola、Chocolate Strawberry Cake、Zampa d'Orso、Albero Celestiale、Quadrifoglio、Albero Gelato、Guardiano del Crepuscolo、Fiore di Pruno、Gerani、Cespuglio di Neve、Ghirlanda di Vischio、Campanula Grandiflora |
| Più suoni esclusivi | Dopo la Neve、Frullato Estivo、Sussurro Autunnale |
| Suoni selezionati | Foresta notturna、(Lofi) Sentiero mattutino、(Lofi) Danza delle rose pigre、Camino Accogliente、Giardino Giapponese、(Piano) Sussurri delle corde del cuore、Ritmo di Risveglio |`)
};

const ja_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus限定の木 | ツツジ、ベニベンケイ、タンポポ、スノードロップ、ヨシ | 
| --- | --- | 
| 厳選された木 | かかし、キノコ、イチョウ、紫のナラの木、チョコイチゴケーキ、熊童子、仙樹、四つ葉のクローバー、サンデーの木、トワイライト・ガーディアン、梅の花、ゼラニウム、シラユキヒメ、ヤドリギのリース、バルーンフラワー |
| Plus限定サウンド | 雪解けのあと、夏の鼓動、秋のささやき | 
| 厳選サウンド | 夜の森、(Lo-Fi) 朝の散歩道、(Lo-Fi) ゆったりとしたバラの舞、居心地の良い暖炉、日本庭園、（ピアノ）心のささやき、目覚めの律動 |`)
};

const ko_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 전용 나무 | 진달래、불꽃 케이티、민들레、눈풀꽃、갈대 | 
| --- | --- | 
| 선택된 나무 | 허수아비、버섯、은행 나무、보라색 참나무、초코릿 딸기 케이크、곰 발바닥、천상의 나무、네잎클로버、초코 아이스크림 나무、트와일라잇 가디언、매화꽃、제라늄、눈송이 덤불、겨우살이 화환、도라지꽃 |
| Plus 전용 사운드 | 눈 내린 후、서머 셰이크、가을의 속삭임 |
| 선택된 사운드 | 깊은 밤의 숲、(로파이) 아침 산책、(로파이) 느긋한 장미의 춤사위、아늑한 벽난로、일본식 정원、(피아노) 마음을 울리는 속삭임、웨이킹 그루브 |`)
};

const pt_br_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Árvores exclusivas Plus  | Azaléia、Flor da fortuna、Dente-de-Leão、Floco de Neve、Caniço |  
| --- | --- | 
| Árvores selecionadas | Espantalho、Cogumelo、Ginkgo、Carvalho Roxo、Bolo de morango com chocolate、Pata de Urso、Árvore Celestial、Trevo de quatro folhas、Árvore Sundae、Guardião do Crepúsculo、Flor de Ameixa、Gerânio、Arbusto Floco de Neve、Guirlanda、Campânula Chinesa |
| Sons exclusivos Plus | Após a neve、Batida de verão、Sussurro do outono |
| Sons selecionados | Noite na Floresta、(Lo-Fi) Trilha matinal、(Lo-Fi) Vagarosa dança da rosa、Lareira aconchegante、Jardim Japonês、(Piano) Sussurros do coração、Ritmo do Despertar |`)
};

const ru_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Эксклюзивные растения Plus | Азалия、Каланхое Блоссфельда、Одуванчик、Подснежник、Тростник | 
| --- | --- | 
| Избранные растения | Cоломенное чучело、Гриб、Гинкго、Фиолетовый дуб、Шоколадно-клубничный торт、Медвежья лапа、Небесное дерево、Четырехлистный клевер、Фруктовое дерево、Сумеречный Хранитель、Цветение сливы、Герань、Куст-снежинка、Рождественская омела、Платикодон |
| Эксклюзивные звуки Plus | После снегопада、Летний шейкер、Осенний шёпот |
| Избранные звуки | Ночной лес、(Lo-Fi) Утренняя тропа、(Lo-Fi) Ленивый танец роз、Уютный камин、Японский сад、(Пианино) Шепот сердечных струн、Пробуждающий ритм |`)
};

const th_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| ต้นไม้สุดพิเศษเฉพาะ Plus  | อาซาเลีย、กุหลาบหิน、แดนดิไลออน、สโนว์ดรอป、ต้นกก |  
| --- | --- | 
| ต้นไม้ที่ถูกคัดสรร | หุ่นไล่กา、เห็ด、ต้นแปะก๊วย、ต้นโอ๊กสีม่วง、เค้กช็อคโกแลตสตรอเบอร์รี่、ต้นอุ้งตีนหมี、ต้นสรวงสวรรค์、โคลเวอร์สี่แฉก、ต้นซันเด、ผู้พิทักษ์แห่งสนธยา、ดอกเหมย、เจอราเนียม、พุ่มเกล็ดหิมะ、พวงมาลัยมิสเซิลโท、ดอกลูกโป่ง |
| เสียงสุดพิเศษเฉพาะ Plus | หลังหิมะผ่านพ้น、จังหวะฤดูร้อน、เสียงกระซิบใบไม้ร่วง |
| เสียงที่ถูกคัดสรร | ป่ายามค่ำคืน、(Lofi) เส้นทางแห่งรุ่งอรุณ、(Lofi) ดอกกุหลาบร่ายรำ、เตาผิงแสนสบาย、สวนญี่ปุ่น、(เปียโน) เสียงกระซิบจากหัวใจ、บีตปลุกพลัง |`)
};

const tr_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Özel Ağaçlar | Açelya、Alevli Katy、Karahindiba、Kardelen、Sazlık | 
| --- | --- | 
| Seçilen Ağaçlar | Korkuluk、Mantar、Mabet Ağacı、Mor Meşe Ağacı、Çikolatalı Çilekli Pasta、Ayı Pençesi Otu、Gök Ağacı、Dört Yapraklı Yonca、Dondurma Ağacı、Alacakaranlık Muhafızı、Erik Çiçeği、Sardunyalar、Kar Tanesi Çalısı、Ökseotu Çelengi、Balon Çiçeği |
| Plus Özel Sesleri | Kardan Sonra、Yaz Çalkantısı、Sonbahar Fısıltısı |
| Seçilen Sesler | Gece Ormanı、(Lofi) Sabah Yolu、(Lofi) Tembel Gül Dansı、Sıcacık Şömine、Japon Bahçesi、(Piyano) Yürek tellerinin fısıltıları、Uyanma Oluğu |`)
};

const zh_cn_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 独享树种  | 杜鹃花、长寿花、蒲公英、雪滴花、芦苇 |  
| --- | --- | 
| 特选树种 | 稻草人、蘑菇、银杏、紫色橡树、巧克力草莓蛋糕、熊童子、仙树、幸运草、圣代树、冬日之光、梅花、天竺葵、白雪木、槲寄生花环、桔梗 |
| Plus 独享声音 | 融雪之后、夏日摇摆、秋之呢喃 |
| 特选声音 | 夜半森林、(Lofi) 晨间小径、(Lofi) 玫瑰花的慵懒、温暖壁炉、日式庭园、（钢琴）心弦低语、清醒律动 |`)
};

const zh_tw_content_2025_q4 = /** @type {(inputs: Content_2025_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 獨享樹種  | 杜鵑花、長壽花、蒲公英、雪滴花、蘆葦 |  
| --- | --- | 
| 精選樹種 | 稻草人、蘑菇、銀杏、紫色橡樹、巧克力草莓蛋糕、熊童子、仙樹、幸運草、聖代樹、冬日之光、梅花、天竺葵、白雪木、槲寄生花環、桔梗 |
| Plus 獨享聲音 | 融雪之後、夏日搖擺、秋之呢喃 |
| 精選聲音 | 夜半森林、(Lofi) 晨間小徑、(Lofi) 玫瑰花的慵懶、溫暖壁爐、日式庭園、（鋼琴）心弦低語、清醒律動 |
`)
};

/**
* | output |
* | --- |
* | "\| Plus-Exclusive Trees \| Azalea、Flaming Katy、Dandelion、Snowdrop、Reed \| \| --- \| --- \| \| Selected Trees \| Scarecrow、Mushroom、Ginkgo、Purple Oak Tree、Chocolate S..." |
*
* @param {Content_2025_Q4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const content_2025_q4 = /** @type {((inputs?: Content_2025_Q4Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_2025_Q4Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_content_2025_q4(inputs)
	if (locale === "ar") return ar_content_2025_q4(inputs)
	if (locale === "de") return de_content_2025_q4(inputs)
	if (locale === "es") return es_content_2025_q4(inputs)
	if (locale === "fr") return fr_content_2025_q4(inputs)
	if (locale === "it") return it_content_2025_q4(inputs)
	if (locale === "ja") return ja_content_2025_q4(inputs)
	if (locale === "ko") return ko_content_2025_q4(inputs)
	if (locale === "pt_br") return pt_br_content_2025_q4(inputs)
	if (locale === "ru") return ru_content_2025_q4(inputs)
	if (locale === "th") return th_content_2025_q4(inputs)
	if (locale === "tr") return tr_content_2025_q4(inputs)
	if (locale === "zh_cn") return zh_cn_content_2025_q4(inputs)
	return zh_tw_content_2025_q4(inputs)
});